<template lang="pug">
  .component-backoffice-operations
    cards(v-if="item", :data="cardData")
    .row.columns
      label Select where the reservations will be moved
        selectize(v-if="options", :options="options", :optionTemplate="optionTemplate", :renderTemplate="optionTemplate", valueField="id", @itemAdded="updateVehicleSlots", @itemRemoved="updateVehicleSlots" ref="selectize")
      button.button(:class="{disabled:!vehicle_slots_id}", :disabled="!vehicle_slots_id", @click="drain") Drain vehicle slot

    .row.columns(v-if="results")
      accordion
        accordion-item(title="Migrated")
          .row(v-for="reservation in results.migrated")
            .column
              h2 Old Reservation
              reservation(:item="reservation.old", type="shortList")
            .column
              h2 New Reservation
              reservation(:item="reservation.new", type="shortList")

        accordion-item(title="Stalled")
          .row(v-for="reservation in results.stalled")
            .column
              h2 Stalled
              reservation(:item="reservation", type="shortList")
</template>

<script>
  import Cards from "../../../components/structure/Cards";
  import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";
  import MaggieHelper from "../../../maggieHelper";
  import Accordion from "../../../components/structure/foundation/Accordion/Accordion";
  import AccordionItem from "../../../components/structure/foundation/Accordion/AccordionItem";
  import Reservation from 'components/backoffice/Reservation'
  import SelectizeVehicleSlot from "../../../components/structure/ui/lists/selectize/SelectizeVehicleSlot";
  import Selectize from "../../../components/structure/Selectize";

  export default {
    name: "Operations",
    created() {

      KeplerBackofficeSdk.vehicleSlots.list().allV2((data) => {
        this.options = data
      })
    },
    data() {

      return {
        results: null,
        options: null,
        vehicle_slots_id: "",
        cardData: [
          {title: 'VS' + this.item.id, value: this.item.name},
          {
            title: 'PL' + this.item.parking_slot.id,
            value: `<a href="/administration/assets/management/${this.item.vehicle.parking_lot.id}">${this.item.vehicle.parking_lot.name}</a>`
          },
          {title: 'PS' + this.item.parking_slot.id, value: this.item.parking_slot.name},
          {title: 'V' + this.item.vehicle.id, value: this.item.vehicle.brand + ' ' + this.item.vehicle.model},]
      }
    },
    methods: {
      updateVehicleSlots() {
        this.vehicle_slots_id = this.$refs.selectize.$data.selectize.getValue()
      },
      drain() {

        KeplerBackofficeSdk.vehicleSlots.select(this.item.id).drain({vehicle_slots_id: [this.vehicle_slots_id]}, (data) => {

          MaggieHelper.notification('drain-result', `Migrated: ${data.migrated.length} -  Stalled: ${data.stalled.length}`)
          this.results = data
        })
      },
      optionTemplate(item, escape) {

        return `<div><div><small><i class="fa fa-car"></i> VS${item.id} ${item.name}</small></div><div>V${item.vehicle.id} ${item.vehicle.brand} ${item.vehicle.model}</div> <div><small>${item.vehicle.plate}</small></div></div>`
      }
    },
    components: {Selectize, SelectizeVehicleSlot, Reservation, AccordionItem, Accordion, Cards},
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Operations.vue?0b572f86